import { render } from "./WaterPage.vue?vue&type=template&id=734ad0c6"
import script from "./WaterPage.vue?vue&type=script&lang=js"
export * from "./WaterPage.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Threejs\\VuejsThreejsForDemo-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__